import { string, array, bool } from 'prop-types'
import { isEmpty } from 'ramda'
import { StackView } from '@telus-uds/components-web'
import NameAndPrice from '../../../atoms/ItemDetails/NameAndPrice/NameAndPrice'
import SubItems from './SubItems'

const HeadingWithSubItems = ({ headingText, headingPriceText, subItems, headingOnly }) => {
  if (isEmpty(subItems) && !headingOnly) return null

  return (
    <StackView space={2}>
      <NameAndPrice name={headingText} price={headingPriceText} />
      <SubItems items={subItems} />
    </StackView>
  )
}

export default HeadingWithSubItems

HeadingWithSubItems.propTypes = {
  headingText: string.isRequired,
  headingPriceText: string,
  subItems: array,
  headingOnly: bool
}

HeadingWithSubItems.defaultProps = {
  headingPriceText: '',
  subItems: [],
  headingOnly: false
}
